import { useState } from 'react';

import { useSearchClient } from '../../../../hooks/use-search-client';

export const useDropdown = (values) => {
  const selectedOption = values.find(({ selected }) => selected);
  const defaultOption = values.length > 0 ? values[0] : undefined;
  const initialValue = selectedOption ?? defaultOption;
  const { handleLinkSPA } = useSearchClient();

  const [itemSelected, setItemSelected] = useState(initialValue);

  const onSelectItem = (e, item) => {
    const newValue = values?.find((value) => value?.id === item);

    if (newValue) {
      setItemSelected(newValue);

      if (!!newValue.url) {
        handleLinkSPA({ href: newValue.url });
      }
    }
  };

  return { itemSelected, onSelectItem };
};
